<!-- 题干组件 -->
<template>
  <div class="screen" :class="seasonClass">
    <div class="page" :class="group === 1 ? 'page1' : 'page2'" :style="pageStyle">
      <div class="userinfo"><span class="mr-20">姓名：{{ userInfo.userName }}</span><span>比赛号码：{{ addZero(userInfo.matchNum) }}</span></div>
      <div class="header" v-if="seasonClass === 'season1'">
        <img class="logo" src="https://cdn.spbcn.org/chineseWord/applets/images/final_center.png">
        <div class="title" :class="group === 1 ? 'title1': ''">{{pageTitle}}</div>
      </div>
      <div class="season2-logo" v-if="seasonClass === 'season2'">
        <img class="img" @click="refresh" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/logo.png" alt="">
        <img class="img" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season3/season3.png" alt="">
      </div>
      <div class="page-box" :class="'page-box' + group">
        <div class="season2-title season2-title1" v-if="group === 1 && seasonClass === 'season2'">
          <div class="cn">小组赛{{ levelFormatter(level, 'cn') }}</div>
          <div class="en">Group Competition {{ levelFormatter(level, 'en') }}</div>
        </div>
        <div class="season2-title season2-title2" @click="refresh" v-if="group === 2 && seasonClass === 'season2'">
          <div class="cn">{{ info.typeName }}</div>
          <div class="en">{{ info.typeEngName }}</div>
        </div>
        <div class="desc">
          <div>{{ info.introduce }}</div>
          <div class="word-break">{{ info.engIntroduce }}</div>
        </div>
        <div class="quiz-number-con">
          <span class="beiyong" v-if="info.isStandby === 1">备用题 {{ info.quizNumber }}</span>
          <div class="quiz-number" v-else>
            第{{ info.quizNumber }}题
          </div>
        </div>
        <!-- 极速拼词 -->
        <div class="content" v-if="info.quizType === 5 && group === 2" :class="vertical">
          <div class="stem-area">
            <div class="type1">
              <el-row>
                <el-col :span="6" v-for="(item,index) of fontList" :key="index">
                  <div class="block" :class="item.active ? 'active-font' : ''" @click="chooseFontFn(item)">{{ item.font }}</div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="answer-area">
            <div class="answer-area-title">答题区</div>
            <div class="flex">
              <div class="block" @click="clearBlockFn(0)">{{ chooseFonts[0] }}</div>
              <div class="block" @click="clearBlockFn(1)">{{ chooseFonts[1] }}</div>
            </div>
          </div>
        </div>

        <!-- 魔力部首 -->
        <div class="content" v-if="info.quizType === 4 && group === 2" :class="vertical">
          <div class="stem-area">
            <div class="type2">
              <div class="block center">{{ info.question }}</div>
              <div class="block" :class="'block'+index"  v-for="(item,index) of fontList" :key="index" @click="answerFn(item, answerNum)">
                <div class="block-inner" :class="item.active ? 'active-font' : ''">
                  {{ item.font }}
                </div>
              </div>
            </div>
          </div>
          <div class="answer-area">
            <div class="answer-area-title">答题区</div>
            <div class="flex">
              <div class="block block2">{{ info.question }}</div>
              <div class="block" @click="clearBlockFn2()">{{ chooseFonts[0] }}</div>
            </div>
          </div>
        </div>

        <!-- 古往今来 -->
        <div class="content3" v-if="info.quizType === 6 && group === 2">
          <div class="answer-area-title">答题区</div>
          <div class="type3" :class="vertical">
            <!-- 图片部分 -->
            <el-row style="margin-bottom: 30px;">
              <el-col :span="6" v-for="(item,index) of imgList" :key="index">
                <div class="block" :class="item.active ? 'active' : ''" @click="answerImgFn(item, index)">
                  <img :src="item.font" alt="">
                </div>
              </el-col>
            </el-row>
            <!-- 文字部分 -->
            <el-row class="area2">
              <el-col :span="8" v-for="(item,index) of fontList" :key="index">
                <div class="block2" :class="item.active ? 'active' : ''" @click="answerFn(item, 2)">{{ item.font }}</div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 有组别 -->
        <div class="content4" v-if="group === 1">
          <div class="answer-area-title">答题区</div>
          <div class="flex">
            <div v-for="(item,index) of fontList" :key="index">
              <div v-if="item.isImg" class="group-block-img" :class="item.active ? 'active' : ''" @click="answerFn(item, answerNum)">
                <img class="font-img" :src="item.font"/>
              </div>
              <div v-else class="group-block" :class="item.active ? 'active' : ''" @click="answerFn(item, answerNum)">
                {{ item.font }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img src="../../assets/img/fs.png" class="fullscreen" @click="toFullOrExit" alt=""> -->
    <!-- 比赛暂停 -->
    <el-dialog :visible.sync="pause" :close-on-click-modal="false" :show-close="false" :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'" width="80%">
      <div class="info-panel" :class="'info-panel-'+seasonClass">
        <div class="info-title">
          <img class="guodu" :src="seasonClass === 'season1' ? 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_guodu_icon.png' : 'https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png'" alt="">
          <div class="cn">比赛暂停，请听候裁判席安排</div>
          <div class="en word-break">The competition is suspended. Please wait for the judges’ instructions.</div>
        </div>
      </div>
    </el-dialog>
    <!-- 两题过渡 -->
    <el-dialog :visible="submit && !discardSubmit" :close-on-click-modal="false" :show-close="false" :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'" width="80%">
      <div class="info-panel" :class="'info-panel-'+seasonClass">
        <div class="info-title">
          <img class="guodu" :src="seasonClass === 'season1' ? 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_guodu_icon.png' : 'https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png'" alt="">
          <div class="cn">已提交，请注意聆听下一题发音</div>
          <div class="en word-break">Your answer has been submitted. Please pay attention to the next question.</div>
        </div>
      </div>
    </el-dialog>
    <!-- 题目作废 -->
    <el-dialog :visible.sync="isDiscard" :close-on-click-modal="false" :show-close="false" :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'" width="80%">
      <div class="info-panel" :class="'info-panel-'+seasonClass">
        <div class="info-title">
          <img class="guodu" :src="seasonClass === 'season1' ? 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_guodu_icon.png' : 'https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png'" alt="">
          <div class="cn">本题已作废，请注意聆听新题目发音</div>
          <div class="en word-break">This question has been invalidated. Please pay attention to the pronunciation of the new question.</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      seasonClass: '',
      pageStyle: {
        height: '100%'
      },
      activityType: '',
      season: '',
      group: 2, // 1-有组别 2无组别
      level: '',
      imgList: [],
      fontList: [], // 答案选项
      vertical: '', // 竖屏class
      isFull: false,
      type: -1, // 题型
      timer: null,
      info: {}, // 试题info
      pageTitle: '',
      dict_group: this.$userInfo.dict_group(),
      userInfo: {}, // 登录用户个人信息
      submit: false, // 小题是否已提交
      discardSubmit: false, // 作废题目提交
      pause: false, // 是否暂停
      answerNum: 0, // 选项数量
      chooseFonts: [], // 选项列表
      chooseImg: '', // 古往今来选择的图片
      isDiscard: false, // 题目作废
      nextStep: false,
      raceSchedule: '' // 赛程
    }
  },
  mounted () {
    this.getScreenSize()
    window.addEventListener('resize', this.getScreenSize)
  },
  beforeDestory () {
    window.removeEventListener('resize', this.getScreenSize)
  },
  created () {
    clearInterval(this.timer)
    console.log(this.$route.query)
    document.title = '汉英双拼大会'
    const season = this.$route.query.s
    this.raceSchedule = this.$route.query.ra // 赛程
    const activityType = this.$route.query.at
    const level = Number(this.$route.query.l)
    this.group = Number(this.$route.query.g)
    this.level = level
    this.activityType = activityType
    this.season = season
    this.userInfo = JSON.parse(localStorage.getItem('PAD_USER_INFO'))
    this.seasonClass = season === '2022~2023' ? 'season1' : season === '2023~2024' ? 'season2' : 'season2'

    this.getMatchStart(activityType, season, level)
    this.timer = setInterval(() => {
      this.getMatchStart(activityType, season, level)
    }, 3000)
  },
  methods: {
    getScreenSize () {
      const w = window.innerWidth
      const h = window.innerHeight
      if (h > w) { // 竖屏
        this.vertical = 'vertical'
        // this.pageStyle.height = parseInt(w * w / h) + 'px'
      } else {
        this.vertical = ''
        // this.pageStyle.height = '100%'
      }
      // console.log(this.vertical)
    },
    requestFullScreen () {
      const de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen () {
      const de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    toFullOrExit () {
      this.isFull = !this.isFull
      if (this.isFull) {
        // this.fullImg = require('@/assets/img/efs.png')
        this.requestFullScreen()
      } else {
        // this.fullImg = require('@/assets/img/fs.png')
        this.exitFullscreen()
      }
    },
    refresh () {
      this.getMatchStart(this.activityType, this.season, this.evel)
    },
    getMatchStart (activityType, season, level) {
      // console.log('获取考场状态')
      const params = { activityType, season, isGroup: this.group, raceSchedule: this.raceSchedule }
      if (Number(this.group) === 1) {
        params.level = level
      }
      this.$http.get('slabForm/queryNationalGroupFormInfoList', { params, showLoading: false }).then(res => {
        if (res.code === 200) {
          // console.log(res.data.matchTng)
          // matchTng： 0未开始， 1 开始比赛   2 结束比赛
          // 获取到题目
          if (res.data.matchTng === 1) {
            if (res.data.groupFormInfo) {
              this.info = { ...res.data.groupFormType, ...res.data.groupFormInfo }
              this.pageTitle = this.group === 2 ? this.info.typeName + ' ' + this.info.typeEngName : `小组赛${this.levelFormatter(level, 'cn')} Group Competition ${this.levelFormatter(level, 'en')}`
              // 作废题目状态重置
              if (this.info.isDiscard === 0) {
                this.isDiscard = false
                this.discardSubmit = false
              }

              const quizIng = res.data.groupFormInfo.quizIng
              if (quizIng === 1) { // 答题中
                this.submit = false
                // 答案
                this.answerNum = this.info.answer.split(',').length
                // console.log(this.answerNum)
                // console.log(this.fontList.length, this.info.isDiscard, this.fontList)
                // 选项
                const options = this.info.choice.split(',')
                if (!this.fontList.length && this.info.isDiscard === 0) { // 作废的题目不展示
                  this.fontList = options.map(item => {
                    return {
                      active: false,
                      font: item,
                      isImg: item.includes('http') ? 1 : 0 // 有组别图片选项
                    }
                  })
                  this.fontList = this.shuffleSimple(this.fontList)
                  if (this.info.quizType === 6) { // 古往今来选项
                    const imgOpt = this.info.choicePic.split(',')
                    this.imgList = imgOpt.map(item => {
                      return {
                        active: false,
                        font: item
                      }
                    })
                    this.imgList = this.shuffleSimple(this.imgList)
                  }
                }
                // 暂停答题
                if (this.info.countDown === 1 && !this.pause) {
                  console.log('暂停计时')
                  this.pause = true
                }
                // 继续作答
                if (this.info.countDown === 2 && this.pause) {
                  console.log('继续作答')
                  this.pause = false
                }
                // 题目作废提交答案
                if (this.info.isDiscard === 1 && !this.isDiscard) {
                  if (!this.discardSubmit) {
                    console.log('作废提交')
                    this.submitFn()
                  }
                  this.isDiscard = true
                }
                // if (this.info.isDiscard === 0 && this.isDiscard) {
                //   this.isDiscard = false
                // }
              }
            } else {
              // 两小题之间过渡状态
              // if (this.group === 1) {
              if (!this.submit && !this.discardSubmit) {
                console.log('答案已提交')
                this.submitFn()
              }
              // }
            }
          } else if (res.data.matchTng === 2) {
            this.$router.go(-1)
            // this.$router.push(`/pad/done?g=${this.group}&season=${season}`)
          }
        }
      })
    },
    // 乱序
    shuffleSimple (array) {
      return [...array].sort(() => Math.random() - 0.5)
    },
    // 保存答案
    submitFn () {
      // 保存答案
      console.log('保存答案')
      // console.log(this.fontList, this.chooseFonts)
      // console.log(this.info)
      const data = {
        activityType: this.activityType,
        season: this.season,
        userId: this.userInfo.userId,
        score: this.calcScore().score,
        nationalId: this.userInfo.id,
        nationalFormId: this.info.nationalFormId,
        nationalFormInfoId: this.info.id,
        nationalGroupId: this.userInfo.nationalGroupId,
        answer: this.calcScore().answer,
        isGroup: this.group,
        raceSchedule: 4,
        phase: 1
      }

      // 将考生答案存到本地缓存
      // localStorage.setItem(`USER_ANSWER_Q${this.info.quizNumber}_G${this.group}`, JSON.stringify(data))
      this.$http.post('slabForm/saveNationalAnswerResult', data).then(res => {
        if (res.code === 200) {
          if (!this.isDiscard) {
            this.submit = true
          } else {
            this.discardSubmit = true
          }
          this.fontList = []
          this.answerNum = 0
          this.chooseFonts = []
          this.chooseImg = ''
          this.pause = false
          console.log(this.fontList)
        }
      })
    },
    calcScore () {
      // const stuList = this.fontList.filter(item => item.active).map(item => item.font)
      if (this.info.quizType === 6 && this.chooseImg) {
        if (!this.chooseFonts.filter(item => item.includes('http')).length) {
          this.chooseFonts.push(this.chooseImg)
        }
      }
      const stuList = this.chooseFonts
      console.log(stuList)
      const ansList = this.info.answer.split(',')
      const inCorrect = ansList.filter(font => !stuList.includes(font))
      return { score: inCorrect.length ? 0 : this.info.questionScore, answer: stuList.join(',') }
    },
    levelFormatter (level, type) {
      return this.dict_group.find(item => item.dictCode === level)[type]
    },
    // 有组别选择答案/魔力部件/古往今来文字
    answerFn (item, answerNum) {
      item.active = !item.active
      if (item.active) {
        if (this.chooseFonts.length < answerNum) {
          this.chooseFonts.push(item.font)
        } else {
          this.fontList.find(item => item.font === this.chooseFonts[0]).active = false
          this.chooseFonts.splice(0, 1)
          this.chooseFonts.push(item.font)
        }
      } else {
        const index = this.chooseFonts.findIndex(font => font === item.font)
        this.chooseFonts.splice(index, 1)
      }
    },
    // 古往今来图片
    answerImgFn (item, index) {
      item.active = !item.active
      this.imgList.filter((img, i) => i !== index).forEach(img => { img.active = false })
      this.chooseImg = item.active ? item.font : ''
    },
    // 极速拼字选答案
    chooseFontFn (item) {
      if (this.chooseFonts.length === this.answerNum) { // 两个空都选上了
        if (this.chooseFonts.filter(font => font === '').length > 0) { // 答题区清空了一个字
          const emptyIndex = this.chooseFonts.findIndex(font => font === '')
          item.active = true
          this.chooseFonts[emptyIndex] = item.font
          this.nextStep = false
        } else { // 答题区选满了
          if (!this.chooseFonts.filter(font => font === item.font).length) {
            // 如果点了新字，清空
            this.chooseFonts = []
            this.fontList.forEach(item => {
              item.active = false
            })
            this.nextStep = true
          } else {
            // 如果点了已选择的字，取消选择
            const clickFontIndex = this.chooseFonts.findIndex(font => font === item.font)
            this.chooseFonts[clickFontIndex] = ''
            item.active = false
            this.nextStep = false
          }
        }
      } else {
        this.nextStep = true
      }

      if (this.nextStep) { // 执行
        item.active = !item.active
        if (item.active) {
          if (this.chooseFonts.length < this.answerNum) {
            this.chooseFonts.push(item.font)
          }
        } else {
          const index = this.chooseFonts.findIndex(font => font === item.font)
          this.chooseFonts.splice(index, 1)
        }
      }
    },
    // 极速拼字清空
    clearBlockFn (index) {
      const font = this.chooseFonts[index]
      this.fontList.find(item => item.font === font).active = false
      this.chooseFonts.splice(index, 1, '')
    },
    // 魔力部件清空
    clearBlockFn2 () {
      this.chooseFonts = []
      this.fontList.forEach(item => {
        item.active = false
      })
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style scoped lang="less">
.fullscreen{
  width: 32px;
  height: 32px;
  position: fixed;
  right: 10px;
  bottom: 10px;
  cursor: pointer;
}
.screen{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  font-family: 'regular';
}
.page{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg2.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
}
.page1{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg1.png);
}
.header{
  margin-top: 32px;
  height: 84px;
  display: flex;
  justify-content: center;
  position: relative;
  .logo{
    width: 220px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
  .title{
    font-size: 28px;
    color: #fff;
    background-color: #b81c25;
    height: 54px;
    line-height: 49px;
    border-radius: 54px;
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 20px;
  }
  .title1{
    background-color: #000;
  }
}
.desc{
    margin: 40px 60px 52px;
    line-height: 24px;
    font-size: 16px;
    color: #000;
  }
.content{
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.answer-area{
  .flex{
    display: flex;
  }
  .block{
    width: 140px;
    height: 140px;
    font-size: 90px;
    color: #000;
    font-family: fzcsk;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    text-align: center;
    // padding-top: 10px;
    line-height: 140px;
    box-sizing: border-box;
    border-radius: 30px;
    background-color: #e5e5e5;
    margin: 10px;
  }
  .block2{
    background-color: transparent;
  }
}
.stem-area{
  width: 318px;
  height: 318px;
  margin-right: 80px;
}
.type1{
  .block{
    width: 66px;
    height: 66px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    text-align: center;
    // padding-top: 4px;
    box-sizing: border-box;
    font-size: 40px;
    background-color: #ffb700;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    border: 2px solid #000;
    border-radius: 18px;
    margin-bottom: 10px;
    font-family: fzcsk;
    line-height: 66px;
  }
}
.type2{
  position: relative;
  .block{
    width: 66px;
    height: 66px;
    font-size: 40px;
    background-color: #fe7d4d;
    border: 2px solid #000;
    border-radius: 18px;
    margin-bottom: 10px;
    position: absolute;
    &.block0{ top: 0; left: 0; }
    &.block1{ top: 0; left: 76px; }
    &.block2{ top: 0; left: 152px; }
    &.block3{ top: 0; left: 228px; }
    &.block4{ top: 76px; left: 0; }
    &.block5{ top: 76px; left: 228px; }
    &.block6{ top: 152px; left: 0; }
    &.block7{ top: 152px; left: 228px; }
    &.block8{ top: 228px; left: 0; }
    &.block9{ top: 228px; left: 76px; }
    &.block10{ top: 228px; left: 152px; }
    &.block11{ top: 228px; left: 228px; }
  }
  .block-inner{
    width: 66px;
    height: 66px;
    text-align: center;
    // padding-top: 4px;
    line-height: 66px;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    font-family: fzcsk;
  }
  .center{
    width: 142px;
    height: 142px;
    line-height: 142px;
    position: absolute;
    top: 76px;
    left: 76px;
    border-radius: 28px;
    font-size: 96px;
    text-align: center;
    font-family: fzcsk;
  }
}
.type3{
  display: flex;
  align-items: center;
  justify-content: center;
  .block{
    width: 90px;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    // border: 6px solid #b81c25;
    border: 4px solid #fff;

    border-radius: 20px;
    margin-right: 16px;
    &.active{
      border-color: #b81c25;
    }
    img{
      height: 90%;
      border-radius: 12px;
    }
  }
  .area2{
    width: 262px;
    margin-left: 40px;
    .block2{
      width: 76px;
      height: 76px;
      text-align: center;
      // padding-top: 7px;
      box-sizing: border-box;
      font-size: 44px;
      background-color: #e5e5e5;
      box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
      border: 2px solid #000;
      border-radius: 14px;
      margin-bottom: 10px;
      font-family: fzcsk;
      line-height: 76px;
      &.active{
        border-color: #b81c25;
        background-color: #ffb700;
      }
    }
  }
}
.answer-area-title{
  font-size: 30px;
  color: #b81c25;
  background-color: #000;
  width: 150px;
  text-align: center;
  height: 54px;
  line-height: 50px;
  border-radius: 54px;
  margin: 0 auto 12px;
}
.content4{
  .flex{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
  }
  .group-block{
    width: 120px;
    height: 120px;
    text-align: center;
    padding-top: 14px;
    box-sizing: border-box;
    font-size: 68px;
    background-color: #e5e5e5;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    border: 2px solid #000;
    border-radius: 20px;
    margin: 10px;
    &.active{
      border-color: #ffb700;
      background-color: #ffb700;
    }
  }
  .group-block-img {
    width: 120px;
    height: 120px;
    text-align: center;
    padding-top: 14px;
    box-sizing: border-box;
    font-size: 68px;
    background-color: #fff;
    border: 6px solid #000;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    border-radius: 20px;
    margin: 10px;
    &.active{
      border-color: #ffb700;
    }
  }
  .font-img{
    height: 80%;
  }
}
// 竖屏
.vertical{
  flex-direction: column;
  align-items: center;
  .stem-area{
    margin: 20px auto;
  }
}

/deep/ .el-dialog__header{
  display: none;
}
/deep/ .el-dialog{
  background-color: transparent;
  box-shadow: none;
}
.info-panel{
  height: 410px;
  background-color: #cbae72;
  border-radius: 60px;
  border: 3px solid #000;
  text-align: center;
  font-size: 32px;
  color: #000;
  box-sizing: border-box;
  padding: 20px 40px 0;
}
.guodu{
  width: 150px;
  height: 150px;
  margin-bottom: 24px;
}
.active-font{
  background-color: #d0d0d0 !important;
}
.userinfo{
  position: absolute;
  right: 24px;
  top: 14px;
  color: #000;
  font-size: 16px;
  font-family: fzcsk;
  .mr-20{
    margin-right: 10px;
  }
}
.season1{
  .page{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg2.png);
  }
}
.season1 .page1{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg1.png);
}
.season2{
  .page{
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/2025/season3_bg_pure.jpg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .season2-logo{
    position: absolute;
    left: 40px;
    right: 40px;
    top: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .img{
      height: 40px;
      width: auto;
    }
  }
  .page-box{
    width: 94%;
    min-height: 70vh;
    background: rgba(255, 248, 225, .7);
    border-radius: 20px;
    padding: 30px 30px 20px;
    box-sizing: border-box;
    margin-top: 60px;
  }
  .userinfo{
    top: 104px;
    right: 58px;
  }
  .page2{
    .userinfo {
      top: 90px;
      right: 38px;
    }
  }
  .info-title{
    margin-top: 32px;
  }
  .answer-area-title{
    color: #fff;
  }
  .content4 .group-block{
    background-color: #fff8e1;
    box-shadow: none;
  }
  .content4 .group-block.active{
    background-color: #f8bc1c;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.1);
  }
  .content4 .group-block-img.active{
    border-color: #b81c25;
  }
  .season2-title{
    height: 64px;
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    font-family: regular;
    text-align: center;
    padding-top: 12px;
    box-sizing: border-box;
    .cn{
      font-size: 20px;
    }
    .en{
      font-size: 12px;
    }
  }
  .season2-title1{
    color: #000;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg2.png);
  }
  .season2-title2{
    color: #fff;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
  }
  .page-box2{
    // background: transparent;
    // margin-top: 0;
    .desc{
      // background: rgba(255, 248, 225, .7);
      // border-radius: 20px;
      padding: 20px;
      margin: 30px 0;
    }
  }
  .type2{
    .block-inner{
      background-color: #fff8e1;
      box-shadow: none;
    }
    .block{
      background-color: #fff8e1;
    }
  }
  .answer-area{
    .block{
      border: 2px solid #000;
      background-color: #fff8e1;
    }
    .block2{
      background: transparent;
      border: none;
    }
  }
  .active-font{
    background-color: #f8bc1c !important;
  }
  .type1 {
    .block{
      background-color: #fff8e1;
      box-shadow: none;
    }
  }
  .type3 {
    .area2{
      .block2{
        background-color: #fff8e1;
        box-shadow: none;
        &.active{
          background-color: #f8bc1c;
          border-color: #000;
        }
      }
    }
  }
}

.info-panel-season2{
  height: 520px;
  border: none;
  background-color: transparent;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
  background-repeat: no-repeat;
  background-size: 90% 100%;
  background-position: center;
  padding-top: 50px;
  box-sizing: border-box;
  .info-con{
    width: 60%;
    background-color: transparent;
    color: #000;
  }
  .info-title{
    color: #000;
    margin-top: 60px;
    font-size: 24px;
    padding: 0 60px;
  }
}
/deep/ .season2-dialog{
  // margin-top: 60px !important;
  margin-bottom: 0 !important;
  .el-dialog__body{
    padding: 0;
  }
}
.quiz-number-con{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  span{
    color: #fff;
    background-color: #b81c25;
    height: 40px;
    line-height: 36px;
    width: 140px;
    text-align: center;
    font-size: 26px;
    border-radius: 30px;
    margin-left: 10px;
  }
}
.quiz-number{
  border: 2px solid #b81c25;
  color: #b81c25;
  border-radius: 40px;
  width: 100px;
  text-align: center;
  height: 40px;
  line-height: 36px;
  font-size: 26px;
  text-align: center;
}
</style>
